import { render, staticRenderFns } from "./PopEmpresa2.vue?vue&type=template&id=7b71c40e&scoped=true"
import script from "./PopEmpresa2.vue?vue&type=script&lang=js"
export * from "./PopEmpresa2.vue?vue&type=script&lang=js"
import style0 from "./PopEmpresa2.vue?vue&type=style&index=0&id=7b71c40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71c40e",
  null
  
)

export default component.exports